document.addEventListener('DOMContentLoaded', function () {
    const quantityInput = document.querySelector('input[name="quantity"]') || { value: 1 };
    const variantSelector = document.querySelector('select[name="id"]');
    const loyaltyPointsElement = document.getElementById('loyalty-points');

    // Fonction pour récupérer le dernier prix affiché
    function getLastPrice() {
        const lastPriceElement = document.querySelector('.price .price__last:last-of-type');
        if (lastPriceElement) {
            return parseFloat(lastPriceElement.textContent.replace(/[^\d.]/g, '')) || 0;
        }
        return 0;
    }

    // Fonction pour mettre à jour les points de fidélité
    function updateLoyaltyPoints() {
        setTimeout(() => { // Attendre un court instant pour que le prix soit bien mis à jour
            const price = getLastPrice();
            const quantity = parseInt(quantityInput.value) || 1;
            const totalPoints = price * quantity * 10;

            if (loyaltyPointsElement) {
                loyaltyPointsElement.textContent = totalPoints;
            }
        }, 200); // Attendre 200ms pour être sûr que le prix est bien mis à jour
    }

    // Écouter les changements de quantité
    if (quantityInput) {
        quantityInput.addEventListener('input', updateLoyaltyPoints);
    }

    // Écouter les changements de variante
    if (variantSelector) {
        variantSelector.addEventListener('change', updateLoyaltyPoints);
    }

    // Vérifier aussi les modifications du DOM pour détecter le changement du prix
    const priceElement = document.querySelector('.price');
    if (priceElement) {
        new MutationObserver(updateLoyaltyPoints).observe(priceElement, { childList: true, subtree: true, characterData: true });
    }

    // Mise à jour initiale
    updateLoyaltyPoints();
});
